import Card from "./Card"
import 'bootstrap/dist/css/bootstrap.css';


function App() {
  return (
    <div className="App ">
     <Card/>
    </div>
  )
}

export default App
